import { useNavigate } from 'react-router-dom';
import { siteStats } from '@/mocks/site';

export default function Hero() {
  const navigate = useNavigate();

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const q = (form.elements.namedItem('q') as HTMLInputElement).value.trim();
    navigate(q ? `/comics?q=${encodeURIComponent(q)}` : '/comics');
  };

  return (
    <section className="relative flex min-h-[560px] w-full items-center justify-center overflow-hidden md:min-h-[640px]">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20dynamic%20comic%20manga%20style%20background%20art%20with%20bold%20geometric%20panels%20and%20energy%20lines%2C%20warm%20coral%20red%2C%20golden%20amber%20and%20cream%20color%20palette%2C%20floating%20speech%20bubbles%20and%20manga%20halftone%20dots%2C%20sweeping%20motion%20arcs%2C%20stylized%20abstract%20illustration%2C%20high%20energy%20heroic%20atmosphere%2C%20wide%20cinematic%20composition&width=1600&height=900&seq=hero-2026-x1&orientation=landscape"
        alt="策驰漫画网 抢先看热门连载"
        title="策驰漫画网 抢先看最新话与同步更新"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-24 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur md:text-sm">
          <i className="ri-fire-fill text-accent-400"></i>
          抢先看最新话 · 同步更新进度 · 汉化进度实时查
        </span>
        <h1 className="font-heading mt-6 text-4xl leading-tight text-white md:text-6xl">
          策驰漫画网
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-background-50/90 md:text-base">
          打开策驰漫画网，第一时间掌握更新动态与抢先看内容。热门连载最新话、同步更新进度、汉化进度一目了然，追更不再错过。
        </p>

        <form
          onSubmit={onSubmit}
          className="mx-auto mt-8 flex max-w-xl flex-col gap-2 sm:flex-row sm:rounded-full sm:bg-background-50 sm:p-1.5"
        >
          <div className="relative flex-1">
            <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400"></i>
            <input
              name="q"
              type="text"
              autoComplete="off"
              placeholder="搜索你想追的漫画，例如 西风斩"
              className="w-full rounded-full bg-background-50 px-11 py-3 text-sm text-foreground-950 outline-none ring-primary-300 placeholder:text-foreground-400 focus:ring-2 sm:rounded-full sm:bg-transparent"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            立即搜索
          </button>
        </form>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <a
            href="#tracking"
            className="inline-flex items-center whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-eye-line mr-1.5"></i>查看追更进度
          </a>
          <a
            href="#latest"
            className="inline-flex items-center whitespace-nowrap rounded-full bg-background-50/15 px-6 py-3 text-sm font-bold text-background-50 backdrop-blur transition-colors hover:bg-background-50/25"
          >
            <i className="ri-flashlight-fill mr-1.5"></i>今日抢先看
          </a>
        </div>

        <dl className="mx-auto mt-12 grid max-w-2xl grid-cols-2 gap-6 sm:grid-cols-4">
          {siteStats.map((s) => (
            <div key={s.label}>
              <dt className="font-heading text-2xl text-accent-400 md:text-3xl">{s.value}</dt>
              <dd className="mt-1 text-xs text-background-50/80">{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}